import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import EmptyStateCard from "../Common/EmptyStateCard";

const GiftsEmptyState = () => {
    const { t } = useTranslation();

    return (
        <EmptyStateCard
            title={t("MY_GIFTS_EMPTY_TITLE")}
            description={t("MY_GIFTS_EMPTY_DESCRIPTION")}
            className="mt-12 px-6 py-16 text-center"
            actionSlot={(
                <Link
                    to="/product-collections"
                    className="btn-secondary mt-6 w-full sm:w-auto"
                >
                    {t("PRODUCT_COLLECTIONS_TITLE")}
                </Link>
            )}
        />
    );
};

export default GiftsEmptyState;
